export const states = [
  "AK",
  "AL",
  "AR",
  "AZ",
  "CA",
  "CO",
  "CT",
  "DC",
  "DE",
  "FL",
  "GA",
  "HI",
  "IA",
  "ID",
  "IL",
  "IN",
  "KS",
  "KY",
  "LA",
  "MA",
  "MD",
  "ME",
  "MI",
  "MN",
  "MO",
  "MS",
  "MT",
  "NC",
  "ND",
  "NE",
  "NH",
  "NJ",
  "NM",
  "NV",
  "NY",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VA",
  "VT",
  "WA",
  "WI",
  "WV",
  "WY",
];

export const US = { name: "United States", code: "US" };
export const Canada = { name: "Canada", code: "CA" };
export const Mexico = { name: "Mexico", code: "MX" };

export const countries = [US, Mexico, Canada];

export const uticaCompany = "utica";
export const foundersCompany = "founders";
export const unknownCompany = "unknown";

export const expandedStates = [
  { state: "Alabama", Abbr: "AL", country: US },
  { state: "Alaska", Abbr: "AK", country: US },
  { state: "Arizona", Abbr: "AZ", country: US },
  { state: "Arkansas", Abbr: "AR", country: US },
  { state: "California", Abbr: "CA", country: US },
  { state: "Colorado", Abbr: "CO", country: US },
  { state: "Connecticut", Abbr: "CT", country: US },
  { state: "Delaware", Abbr: "DE", country: US },
  { state: "District of Columbia", Abbr: "DC", country: US },
  { state: "Florida", Abbr: "FL", country: US },
  { state: "Georgia", Abbr: "GA", country: US },
  { state: "Guam", Abbr: "GU", country: US },
  { state: "Hawaii", Abbr: "HI", country: US },
  { state: "Idaho", Abbr: "ID", country: US },
  { state: "Illinois", Abbr: "IL", country: US },
  { state: "Indiana", Abbr: "IN", country: US },
  { state: "Iowa", Abbr: "IA", country: US },
  { state: "Kansas", Abbr: "KS", country: US },
  { state: "Kentucky", Abbr: "KY", country: US },
  { state: "Louisiana", Abbr: "LA", country: US },
  { state: "Maine", Abbr: "ME", country: US },
  { state: "Maryland", Abbr: "MD", country: US },
  { state: "Massachusetts", Abbr: "MA", country: US },
  { state: "Michigan", Abbr: "MI", country: US },
  { state: "Minnesota", Abbr: "MN", country: US },
  { state: "Mississippi", Abbr: "MS", country: US },
  { state: "Missouri", Abbr: "MO", country: US },
  { state: "Montana", Abbr: "MT", country: US },
  { state: "Nebraska", Abbr: "NE", country: US },
  { state: "Nevada", Abbr: "NV", country: US },
  { state: "New Hampshire", Abbr: "NH", country: US },
  { state: "New Jersey", Abbr: "NJ", country: US },
  { state: "New Mexico", Abbr: "NM", country: US },
  { state: "New York", Abbr: "NY", country: US },
  { state: "North Carolina", Abbr: "NC", country: US },
  { state: "North Dakota", Abbr: "ND", country: US },
  { state: "Northern Mariana Islands", Abbr: "MP", country: US },
  { state: "Ohio", Abbr: "OH", country: US },
  { state: "Oklahoma", Abbr: "OK", country: US },
  { state: "Oregon", Abbr: "OR", country: US },
  { state: "Pennsylvania", Abbr: "PA", country: US },
  { state: "Puerto Rico", Abbr: "PR", country: US },
  { state: "Rhode Island", Abbr: "RI", country: US },
  { state: "South Carolina", Abbr: "SC", country: US },
  { state: "South Dakota", Abbr: "SD", country: US },
  { state: "Tennessee", Abbr: "TN", country: US },
  { state: "Texas", Abbr: "TX", country: US },
  { state: "Utah", Abbr: "UT", country: US },
  { state: "Vermont", Abbr: "VT", country: US },
  { state: "Virginia", Abbr: "VA", country: US },
  { state: "Virgin Islands", Abbr: "VI", country: US },
  { state: "Washington", Abbr: "WA", country: US },
  { state: "West Virginia", Abbr: "WV", country: US },
  { state: "Wisconsin", Abbr: "WI", country: US },
  { state: "Wyoming", Abbr: "WY", country: US },
  { state: "Alberta", Abbr: "AB", country: Canada },
  { state: "British Columbia", Abbr: "BC", country: Canada },
  { state: "Manitoba", Abbr: "MB", country: Canada },
  { state: "Newfoundland and Labrador", Abbr: "NL", country: Canada },
  { state: "New Brunswick", Abbr: "NB", country: Canada },
  { state: "Northwest Territories", Abbr: "NT", country: Canada },
  { state: "Nova Scotia", Abbr: "NS", country: Canada },
  { state: "Ontario", Abbr: "ON", country: Canada },
  { state: "Prince Edward Island", Abbr: "PE", country: Canada },
  { state: "Quebec", Abbr: "QC", country: Canada },
  { state: "Saskatchewan", Abbr: "SK", country: Canada },
  { state: "Yukon", Abbr: "YT", country: Canada },
];

export const escalationCriteria = [
  "Brain Injuries",
  "Catastrophic Events Involving Multiple Claimants",
  "Extreme Weather Involved/Hurricane",
  "Fatality",
  "Severe Burns",
  "Severe Eye/Ear Injury",
  "Sexual Assault/Hostage Situation/Shooting",
  "Spinal Cord Injuries",
  "Toxic Exposures",
  "Transported by Air",
];

export const propertyTypes = [
  "CPP",
  "CP",
  "BOP",
  "GAC",
  "IM",
  "CIM",
  "PROP",
  "InlandMarine",
  "Property",
];

export const liabilityTypes = [
  "CPP",
  "CP",
  "BOP",
  "GAC",
  "LIAB",
  "PROP",
  "GeneralLiability",
  "Property",
];

export const apps = {
  Claims: "Claims",
  DriveRight: "DriveRight",
  Esignature: "Esignature",
};

export const unknownName = "(unknown)";
